import React, { useState } from 'react'
import qs from 'qs'
import { useQuery } from '@tanstack/react-query'
import { Button } from '@mui/material'
import { BasicCard, Footer } from './components'
import Modal from '@/components/Modal'
import Text from '@/components/Text'
import { bindWeChatInfo } from '@/api'

export interface BindWechatProps {
  open: boolean;
  onClose: () => void;
}

const BindWechat: React.FC<BindWechatProps> = (props) => {
  const { open, onClose } = props
  const [app, setApp] = useState<string>('')
  const [state, setState] = useState<string>('')
  const [redirect, setRedirect] = useState<string>(location.href)
  useQuery(['bindWeChatInfo'], bindWeChatInfo, {
    onSuccess: (res) => {
      setApp(res.appId)
      setState(res.state)
      setRedirect(res.redirectUrl ?? location.href ?? '/')
    },
    enabled: open,
  })

  const search = {
    appid: app || 'wxe5aacf23fcf17924',
    redirect_uri: encodeURI(redirect || location.href),
    login_type: 'jssdk',
    self_redirect: 'default',
    style: 'black',
    scope: 'snsapi_login',
    state: state || '0001',
    href: `${location.origin}/main.css`,
  }
  const src = `https://open.weixin.qq.com/connect/qrconnect?${qs.stringify(
    search,
    { encode: false }
  )}`

  return (
    <Modal width={500} open={open} onClose={onClose}>
      <BasicCard>
        <Text>绑定微信</Text>
        <BasicCard
          sx={{
            justifyContent: 'center',
            backgroundColor: 'transparent',
            backgroundImage: 'none',
            border: 'none',
            boxShadow: 'none',
            margin: 'auto',
          }}
        >
          <iframe
            style={{ overflow: 'hidden' }}
            src={src}
            height={200}
            width={200}
            sandbox={'allow-scripts allow-top-navigation'}
            frameBorder={0}
            scrolling={'no'}
          />
        </BasicCard>
        <Footer>
          <Button variant="outlined" onClick={onClose}>
            取消
          </Button>
        </Footer>
      </BasicCard>
    </Modal>
  )
}

export default BindWechat
